import { lazy } from "react";
// project import
import Loadable from "components/Loadable";
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| ROUTES ITEMS - FIRE DAMAGE PAGE||============================== //

// render - fire damage
const FireDamage = Loadable(
    lazy(() => import("pages/nostradamus/fire-damage/FireDamagePage"))
);

const fire_damage = {
    path: "fire-damage",
    element: (
        // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
        <FireDamage />
        // </RequireAuthorizedAccess>
    ),
};

export default fire_damage;
